module.exports = __webpack_public_path__ + "static/media/outline-format_bold-24px.b3be8994.svg";